import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyUsersSection from './components/WhyUsersSection';
import FeaturedResources from './components/FeaturedResources';
import ComparisonSection from './components/ComparisonSection';
import SafetyCenter from './components/SafetyCenter';
import ArticleSection from './components/ArticleSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoospread.us';
const siteUrlTrailing = siteUrl.replace(/\/$/, '');

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Sugargoo Spreadsheet Hub',
    url: `${siteUrlTrailing}/`,
    description: 'The ultimate independent resource for Sugargoo Spreadsheet guides, reviews, shipping information, and shopping tutorials.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrlTrailing}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Sugargoo Spreadsheet Hub',
    url: `${siteUrlTrailing}/`,
    description: 'Independent resource providing Sugargoo Spreadsheet guides, product discovery tools, shipping cost breakdowns, warehouse guides and shopping tutorials.',
    sameAs: ['https://kaspreadsheet.com'],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${siteUrlTrailing}/`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <WhyUsersSection />
        <FeaturedResources />
        <ComparisonSection />
        <SafetyCenter />
        <ArticleSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </div>
  );
}